import React from "react";
import "./WidgetWarning.scss";

export const WidgetWarning = ({ text, onClose }: { text: string; onClose: () => void }): JSX.Element => {
    return (
        <div className="widget-warning">
            <div className="warning-content">
                <div className="circled">!</div>
                <div className="warning-text">{text}</div>
                <div className="close" onClick={onClose}>
                    ⤫
                </div>
            </div>
        </div>
    );
};
